export const SELECT_COLLECTION = 'zola/registryCollection/SELECT_COLLECTION';
export const TOGGLE_FACET_VALUE = 'zola/registryCollection/TOGGLE_FACET_VALUE';
export const RESET_FACET_VALUES = 'zola/registryCollection/RESET_FACET_VALUES';
export const UPDATE_SORT = 'zola/registryCollection/UPDATE_SORT';
export const RECEIVE_SEARCH = 'zola/registryCollection/RECEIVE_SEARCH';
export const REQUEST_SEARCH = 'zola/registryCollection/REQUEST_SEARCH';
export const RESET = 'zola/registryCollection/RESET';
export const REQUEST_DEFAULT_GIFT_CARD = 'zola/registryCollection/REQUEST_DEFAULT_GIFT_CARD';
export const RECEIVE_DEFAULT_GIFT_CARD = 'zola/registryCollection/RECEIVE_DEFAULT_GIFT_CARD';
export const REQUEST_ADD_TO_REGISTRY = 'zola/registryCollection/REQUEST_ADD_TO_REGISTRY';
export const RECEIVE_ADD_TO_REGISTRY = 'zola/registryCollection/RECEIVE_ADD_TO_REGISTRY';
export const REQUEST_REGISTRY_ITEM_BY_COLLECTION_ITEM_ID =
  'zola/registryCollection/REQUEST_REGISTRY_ITEM_BY_COLLECTION_ITEM_ID';
export const RECEIVED_REGISTRY_ITEM_BY_COLLECTION_ITEM_ID =
  'zola/registryCollection/RECEIVED_REGISTRY_ITEM_BY_COLLECTION_ITEM_ID';
